import CardNavButton, { CardNavButtonVariant } from "UIPalette/CardNavButton/CardNavButton";
import classNames from "classnames";
import { useAppReviewContext } from "core/state/AppReviewContext/AppReviewContext";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Chip } from "shared/UI/Chip/Chip";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import { Course } from "shared/request/myHealthyAdvantageApi";

interface CourseCardProps {
  courseData: Course;
  className?: string;
}

export const CourseCard = ({ courseData, className }: CourseCardProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: "courseCard" });
  const navigate = useNavigate();
  const { handlePositiveMoment } = useAppReviewContext();

  const handleOpenCourse = () => {
    navigate(`/wisdom-academy/course/${courseData.id}`);
    handlePositiveMoment();
  };

  const completionState = (
    <>
      <div className="absolute right-0 bottom-0 w-full h-full bg-[linear-gradient(to_top_left,rgba(0,0,0,1)_0%,transparent_60%)]"></div>
      <div className="absolute right-0 bottom-0 p-4 pointer-events-none">
        <Chip theme="tertiary" boldText text={t("complete")} />
      </div>
    </>
  );

  return (
    <RoundedCard className={classNames("flex flex-col !p-0 overflow-hidden py-6", className)}>
      <div className="relative">
        <img
          className="h-[160px] w-full object-cover"
          srcSet={courseData?.image?.responsiveImage?.webpSrcSet}
          alt={courseData?.image?.responsiveImage?.alt || courseData?.title}
        />
        {courseData?.status === "Completed" && completionState}
      </div>
      <div className="grow flex flex-col justify-between items-start">
        <div className="p-6">
          <h3 className="line-clamp-2 !p-0 mb-2">{courseData?.title}</h3>
          <p className="line-clamp-2">{courseData?.aboutCourse}</p>
        </div>
        <CardNavButton variant={CardNavButtonVariant.Secondary} label={t("cta")} onClick={handleOpenCourse} />
      </div>
    </RoundedCard>
  );
};
